
import KeyenceHTHardKeyButton from '@/components/keyenceHT/hardkeys/KeyenceHTHardKeyButton.vue'
import KeyenceHTScannerMixin from '@/components/mixins/KeyenceHTScannerMixin.vue'
import OCRComponent from '@/components/OCRComponent.vue'
import ScanComponent from '@/components/ScanComponent.vue'
import IconScanQR from '@/components/svg/IconScanQR.vue'
import { SAVE_SCANNED_WORK_CENTER_CODE } from '@/store/actions'
import { LOCAL_STORAGE_ITEM } from '@/utils/constants'
import { EBCRType, ECameraReaderType } from '@/utils/enums'
import { logError } from '@/utils/errorLogger'
import { openMessage } from '@/utils/helpers'
import { KeyenceHardKey } from '@/utils/keyenceHT/keyenceHardKeyEventHandler'
import { isKeyenceEnterpriseBrowser, KeyenceModule } from '@/utils/keyenceHT/keyenceModules'
import { mixins, Options } from 'vue-class-component'
import { Prop, PropSync, Watch } from 'vue-property-decorator'
@Options({
  name: 'ActionDialog',
  emits: ['update:isShowActionDialog', 'update:confirm'],
  components: {
    OCRComponent,
    ScanComponent,
    KeyenceHTHardKeyButton,
    IconScanQR,
  },
})
export default class ActionDialogWorkCenter extends mixins(KeyenceHTScannerMixin) {
  @PropSync('isShowActionDialog', { type: Boolean }) syncedModel?: boolean
  @Prop({ default: ECameraReaderType.BCR }) actionType!: ECameraReaderType
  @Prop({ type: String }) readonly fieldName!: string
  @Prop({ default: EBCRType.DEFAULT }) customBarcodeReaderType!: EBCRType
  @Prop({ type: Boolean }) readonly isShowMultipleScan?: boolean

  scannedValue = ''
  validationError = ''
  isOpenValidationError = false
  KeyenceHardKey = KeyenceHardKey

  get currentManufacturingWRKC() {
    return this.barcode.manufacturingPlan?.workCenterCode || ''
  }

  get barcode() {
    return this.$store.state.barcode?.barcode
  }

  workCenterCodeFromStore() {
    return localStorage.getItem(LOCAL_STORAGE_ITEM.WORK_CENTER_CODE) || ''
  }

  @Watch('syncedModel')
  onDialogVisibilityChange(isOpen: boolean) {
    this.scannedValue = this.workCenterCodeFromStore()
    this.validationError = ''
    this.isOpenValidationError = false
    if (isOpen) {
      this.startKeyenceScan()
    } else {
      this.stopKeyenceScan()
    }
  }

  onDialogClosing() {
    this.syncedModel = false
    // if (this.$refs?.ocrComponent) this.$refs.ocrComponent.vidOff()
  }

  toggleKeyenceScanner() {
    if (this.isScanning) {
      this.stopKeyenceScan()
    } else {
      this.startKeyenceScan()
    }
  }

  startKeyenceScan() {
    if (this.isEnabledBarcodeReadWithKeyenceHT) {
      this.isScanning = true
      this.startScanWithKeyenceHT(this.handleKeyenceScanSuccess, undefined, false)
    }
  }

  stopKeyenceScan() {
    try {
      if (this.isEnabledBarcodeReadWithKeyenceHT && KeyenceModule && KeyenceModule.Scanner) {
        KeyenceModule.Scanner.stopRead()
        KeyenceModule.Scanner.clearReadCallback()
        this.isScanning = false
      }
    } catch (e) {
      console.error(e)
    } finally {
      this.isScanning = false
    }
  }

  handleKeyenceScanSuccess(detectedText: string) {
    openMessage(detectedText, 'success')
    const trimmedText = detectedText.trim()
    this.scannedValue = trimmedText
    this.validationError = ''
  }

  get isEnabledBarcodeReadWithKeyenceHT() {
    return isKeyenceEnterpriseBrowser()
  }

  confirmText(text: string) {
    const trimmedText = text.trim()
    this.scannedValue = trimmedText

    if (this.fieldName === 'workCenterCode') {
      if (!this.validateWorkCenterCode(trimmedText)) {
        return
      }
      this.$store.dispatch(SAVE_SCANNED_WORK_CENTER_CODE, trimmedText)
    }

    this.validationError = ''
    this.stopKeyenceScan()
    this.$emit('update:confirm', trimmedText)
  }

  validateWorkCenterCode(scannedCode: string): boolean {
    this.validationError = ''
    this.isOpenValidationError = false

    if (!scannedCode) {
      this.validationError = 'work_center_code_required'
      this.isOpenValidationError = true
      logError('', {}, '', this.$t('work_center_code_required'))
      return false
    }

    if (!scannedCode.includes(this.currentManufacturingWRKC)) {
      this.validationError = 'work_center_code_mismatch'
      this.isOpenValidationError = true
      logError('', {}, '', this.$t('work_center_code_mismatch'))
      return false
    }

    return true
  }

  resetScannedValue() {
    this.scannedValue = ''
    this.validationError = ''
    this.isOpenValidationError = false
  }

  unmounted() {
    this.stopKeyenceScan()
    this.unmountedKeyenceHTScanner()
  }

  get component() {
    switch (this.actionType) {
      case ECameraReaderType.BCR:
        return {
          item: ScanComponent,
          props: {
            fieldName: this.fieldName,
            customBarcodECameraReaderType: this.customBarcodeReaderType,
            initialValue: this.scannedValue,
            isShowMultipleScanData: this.isShowMultipleScan,
            isReadOnlyInput: true,
          },
        }
      case ECameraReaderType.OCR:
        return {
          item: OCRComponent,
          props: {
            fieldName: this.fieldName,
            initialValue: this.scannedValue,
            isShowMultipleScanData: this.isShowMultipleScan,
          },
        }
      default:
        return {
          item: ScanComponent,
          props: {
            fieldName: this.fieldName,
            customBarcodECameraReaderType: this.customBarcodeReaderType,
            initialValue: this.scannedValue,
            isShowMultipleScanData: this.isShowMultipleScan,
          },
        }
    }
  }
}
